const nasobilkaCtyr = () => {
	return [
		{
			id: 1,
			priklad: '4 x 4',
			moznosti: [
				{
					id: 1,
					moznost: '24',
				},
				{
					id: 2,
					moznost: '20',
				},
				{
					id: 3,
					moznost: '12',
				},
				{
					id: 4,
					moznost: '16',
				},
			],
			vysledek: '16',
		},
		{
			id: 2,
			priklad: '20 : 4',
			moznosti: [
				{
					id: 1,
					moznost: '5',
				},
				{
					id: 2,
					moznost: '4',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '6',
				},
			],
			vysledek: '5',
		},
		{
			id: 3,
			priklad: '4 x 3',
			moznosti: [
				{
					id: 1,
					moznost: '20',
				},
				{
					id: 2,
					moznost: '16',
				},
				{
					id: 3,
					moznost: '12',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '12',
		},
		{
			id: 4,
			priklad: '16 : 4',
			moznosti: [
				{
					id: 1,
					moznost: '4',
				},
				{
					id: 2,
					moznost: '5',
				},
				{
					id: 3,
					moznost: '6',
				},
				{
					id: 4,
					moznost: '3',
				},
			],
			vysledek: '4',
		},
		{
			id: 5,
			priklad: '4 x 2',
			moznosti: [
				{
					id: 1,
					moznost: '12',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '4',
				},
				{
					id: 4,
					moznost: '16',
				},
			],
			vysledek: '8',
		},
		{
			id: 6,
			priklad: '6 x 4',
			moznosti: [
				{
					id: 1,
					moznost: '20',
				},
				{
					id: 2,
					moznost: '24',
				},
				{
					id: 3,
					moznost: '28',
				},
				{
					id: 4,
					moznost: '16',
				},
			],
			vysledek: '24',
		},
		{
			id: 7,
			priklad: '10 x 4',
			moznosti: [
				{
					id: 1,
					moznost: '40',
				},
				{
					id: 2,
					moznost: '36',
				},
				{
					id: 3,
					moznost: '32',
				},
				{
					id: 4,
					moznost: '28',
				},
			],
			vysledek: '40',
		},
		{
			id: 8,
			priklad: '28 : 4',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '9',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '7',
		},
		{
			id: 9,
			priklad: '24 : 4',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '6',
				},
				{
					id: 3,
					moznost: '8',
				},
				{
					id: 4,
					moznost: '5',
				},
			],
			vysledek: '6',
		},
		{
			id: 10,
			priklad: '12 : 4',
			moznosti: [
				{
					id: 1,
					moznost: '2',
				},
				{
					id: 2,
					moznost: '5',
				},
				{
					id: 3,
					moznost: '4',
				},
				{
					id: 4,
					moznost: '3',
				},
			],
			vysledek: '3',
		},
		{
			id: 11,
			priklad: '32 : 4',
			moznosti: [
				{
					id: 1,
					moznost: '8',
				},
				{
					id: 2,
					moznost: '7',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '6',
				},
			],
			vysledek: '8',
		},
		{
			id: 12,
			priklad: '9 x 4',
			moznosti: [
				{
					id: 1,
					moznost: '32',
				},
				{
					id: 2,
					moznost: '36',
				},
				{
					id: 3,
					moznost: '40',
				},
				{
					id: 4,
					moznost: '28',
				},
			],
			vysledek: '36',
		},
		{
			id: 13,
			priklad: '4 x 0',
			moznosti: [
				{
					id: 1,
					moznost: '2',
				},
				{
					id: 2,
					moznost: '4',
				},
				{
					id: 3,
					moznost: '1',
				},
				{
					id: 4,
					moznost: '0',
				},
			],
			vysledek: '0',
		},
		{
			id: 14,
			priklad: '5 x 4',
			moznosti: [
				{
					id: 1,
					moznost: '28',
				},
				{
					id: 2,
					moznost: '16',
				},
				{
					id: 3,
					moznost: '20',
				},
				{
					id: 4,
					moznost: '24',
				},
			],
			vysledek: '20',
		},
		{
			id: 15,
			priklad: '2 x 4',
			moznosti: [
				{
					id: 1,
					moznost: '4',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '16',
				},
				{
					id: 4,
					moznost: '12',
				},
			],
			vysledek: '8',
		},
		{
			id: 16,
			priklad: '7 x 4',
			moznosti: [
				{
					id: 1,
					moznost: '20',
				},
				{
					id: 2,
					moznost: '32',
				},
				{
					id: 3,
					moznost: '28',
				},
				{
					id: 4,
					moznost: '24',
				},
			],
			vysledek: '28',
		},
		{
			id: 17,
			priklad: '24 : 4',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '7',
				},
			],
			vysledek: '6',
		},
		{
			id: 18,
			priklad: '7 x 4',
			moznosti: [
				{
					id: 1,
					moznost: '24',
				},
				{
					id: 2,
					moznost: '28',
				},
				{
					id: 3,
					moznost: '32',
				},
				{
					id: 4,
					moznost: '20',
				},
			],
			vysledek: '28',
		},
		{
			id: 19,
			priklad: '40 : 4',
			moznosti: [
				{
					id: 1,
					moznost: '10',
				},
				{
					id: 2,
					moznost: '9',
				},
				{
					id: 3,
					moznost: '8',
				},
				{
					id: 4,
					moznost: '7',
				},
			],
			vysledek: '10',
		},
		{
			id: 20,
			priklad: '10 x 4',
			moznosti: [
				{
					id: 1,
					moznost: '40',
				},
				{
					id: 2,
					moznost: '32',
				},
				{
					id: 3,
					moznost: '36',
				},
				{
					id: 4,
					moznost: '28',
				},
			],
			vysledek: '40',
		},
		{
			id: 21,
			priklad: '4 x 6',
			moznosti: [
				{
					id: 1,
					moznost: '24',
				},
				{
					id: 2,
					moznost: '28',
				},
				{
					id: 3,
					moznost: '22',
				},
				{
					id: 4,
					moznost: '20',
				},
			],
			vysledek: '24',
		},
		{
			id: 22,
			priklad: '7 x 4',
			moznosti: [
				{
					id: 1,
					moznost: '21',
				},
				{
					id: 2,
					moznost: '28',
				},
				{
					id: 3,
					moznost: '35',
				},
				{
					id: 4,
					moznost: '42',
				},
			],
			vysledek: '28',
		},
		{
			id: 23,
			priklad: '9 x 4',
			moznosti: [
				{
					id: 1,
					moznost: '40',
				},
				{
					id: 2,
					moznost: '32',
				},
				{
					id: 3,
					moznost: '28',
				},
				{
					id: 4,
					moznost: '36',
				},
			],
			vysledek: '36',
		},
		{
			id: 24,
			priklad: '2 x 4',
			moznosti: [
				{
					id: 1,
					moznost: '16',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '4',
				},
				{
					id: 4,
					moznost: '12',
				},
			],
			vysledek: '8',
		},
	];
};

export default nasobilkaCtyr;
